import { interleave } from '@theme/excello-family';
import { StandardEvents } from '@shopify/events';

function arrange(root=document) {
  for (const list of root.querySelectorAll('[data-family-list], .resource-list slideshow-slides')) {
    const children=[...list.children];
    const cards=children.filter(child=>child.matches('[data-family]')||child.querySelector('[data-family]'));
    if(cards.length<2)continue;
    const ordered=interleave(cards);
    if(cards.every((card,index)=>card===ordered[index]))continue;
    for(let index=0;index<ordered.length;index++){
      const current=[...list.children].filter(child=>cards.includes(child))[index];
      if(current===ordered[index])continue;
      if(typeof list.moveBefore==='function')list.moveBefore(ordered[index],current||null);
      else list.insertBefore(ordered[index],current||null);
    }
    list.dataset.familyOrdered='true';
  }
}
arrange();
document.addEventListener('shopify:section:load',event=>arrange(event.target));

document.addEventListener(StandardEvents.searchUpdate, async event => {
  const search=event.target instanceof Element?event.target.closest('predictive-search-component'):null;
  if(!search)return;
  try {if(event.promise)await event.promise;if(search.isConnected)arrange(search);}catch(_){}
});

